//用户列表的功能
import request from './request'

//获取员工列表
export function _adminIndex(data = {}) {
    const config = Object.assign(data, {
      method: 'get',
      url: '/admin/admin/index',
    })
    return request(config)
}

//更新员工的状态
export function _adminUpdateState(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url:'/admin/admin/update-state',
  })
  return request(config)
}

//获取指定ID的员工信息
export function _adminSingleInfo(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url:'admin/admin/getinfo',
  })
  return request(config)
}

// 员工信息编辑
export function _adminEdit(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url:'/admin/admin/edit',
  })
  return request(config)
}

//员工注册
export function _adminAdd(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url:'/admin/admin/add',
  })
  return request(config)
}

//员工退出
export function _adminLogout(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url:'/admin/admin/logout',
  })
  return request(config)
}

//员工登录
export function _adminLogin(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url:'/admin/admin/login',
  })
  return request(config)
}


